import { Component, Input } from "@angular/core";
import { Lottie } from "../../constant/lottie";

@Component({
    selector: "web-celebration",
    templateUrl: "./celebration.component.html",
    styleUrls: ["./celebration.component.scss"],
})
export class CelebrationComponent {
    @Input() filePath: any;
    constructor(public lottie: Lottie) {}
}
